'use-strict';

module.exports = ['$scope', '$transitions', '$state', '$stateParams', 'ngDroUAA', 'ngDroUtilsNotify', '$translate', '$anchorScroll',
    function ($scope, $transitions, $state, $stateParams, ngDroUAA, ngDroUtilsNotify, $translate, $anchorScroll) {
        /*
         * Config
         */

        // Informazioni per la parametrizzazione della direttiva buttonadd
        // $scope.infoTitle = {icon: 'fa-shield fa-fw', message: 'jdro_role.modal.title'};

        // parametri per la richiesta canDo
        const params = {
            resource: "ROLE",
            privilege: $stateParams.id ? "UPDATE" : "CREATE"
        };

        /*
         * Init 
         */

        $scope.role = null;
        // Controllo se l'utente modifica qualche campo con JSON.stringfy 
        var backupRole = {};

        // conterrà i permessi
        $scope.jdroPerms = {};

        // Ottengo i permessi per le operazioni Update o Create   
        ngDroUAA.Profile.canDo(params.resource, params.privilege)
                .then(function (result) {
                    $scope.jdroPerms[params.privilege] = result.data;
                    if ($scope.jdroPerms[params.privilege] === true) {
                        
                        getAllPerms();
                        
                        // Setto un listener su transition start :
                        //      se ho cambiato qualche campo e non ho salvato faccio uscire un modal di conferma.
                        $scope.deregisterListener = $transitions.onStart({to: '*'}, catchStateTransition);
                        ngDroUtilsNotify.setDeregisterListner( $scope.deregisterListener );
                    }
                });

        /*
         * Methods
         */

        // mi serve nel template per disabilitare i campi 
        $scope.hasPerms = function () {
            return $stateParams.id ? $scope.jdroPerms.UPDATE : $scope.jdroPerms.CREATE;
        };

        // Salvataggio del nuovo Role.
        $scope.submit = function (isValid, next) {

            $scope.submitted = true;

            if (!isValid) {
                $anchorScroll('ng-dro-uaa-roleDetail');
                return;
            }

            /**
             * Nel momento del salvataggio di una riga cerco di capire 
             * se sono in fase di inserimento o di update.
             * Se l'id è null, allora andremo ad effettuare una insert in modalità POST.
             * Altrimenti se l'id è null, andrà effettuato un update in modalità PUT.
             */
            pushPerms();

            if (angular.isUndefined($stateParams.id)) {
                ngDroUAA.Role.save($scope.role)
                        .then(function () {
                            ngDroUtilsNotify.insertSuccess($scope.role.roleCode);
                            //$scope.loadRoles();
                            $scope.redirect(next);
                        })
                        .catch(function (err) {
                            ngDroUtilsNotify.insertError($scope.role.roleCode, err);
                        });
            } else {
                //role.id = id;           
                ngDroUAA.Role.update($scope.role)
                        .then(function () {
                            ngDroUtilsNotify.updateSuccess($scope.role.roleCode);
                            //$scope.loadRoles();
                            $scope.redirect(next);
                        })
                        .catch(function (err) {
                            ngDroUtilsNotify.updateError($scope.role.roleCode, err);
                        });
            }
        };

        // Cancel del form
        $scope.cancel = function () {
            $state.go('uaa-module-role-list');
        };

        // Redirect alla pagina della lista.
        $scope.redirect = function (next) {
            ngDroUtilsNotify.unregisterListner();
            next = next ? next : "uaa-module-role-list";
            $state.go(next);
        };

        // Inizializza i valori dei toogle
        $scope.initPerms = function (perm, value) {
            if (Object.keys($scope.role).length !==0 ) {
                angular.forEach($scope.role.rolePermissions, function (role_privilege, index_i) {
                    if (role_privilege.resource === perm.resource && value.name === role_privilege.privilege) {
                        value.enabled = true;
                    }
                });
            }
        };

        // Setta i valori dei toogle nel ruolo
        function pushPerms() {
            if (!angular.isUndefined($scope.role)) {
                $scope.role.rolePermissions = [];
                angular.forEach($scope.perms, function (perm, index_i) {
                    angular.forEach(perm.allowedPerms, function (elem, index_j) {
                        if (!angular.isUndefined(elem.enabled) && elem.enabled) {
                            var permission = {};
                            permission.resource = perm.resource;
                            permission.privilege = elem.name;
                            $scope.role.rolePermissions.push(permission);
                        }
                    });
                });
            }
        }

        // tolgo il campo id dal controllo
        function replacer(key, value) {
            if (this && key === "id")
                return undefined;
            return value;
        }

        // per $transitions, cattura gestisce unsaved changes
        function catchStateTransition(transition) {
            pushPerms();

            if (JSON.stringify($scope.role, replacer) !== JSON.stringify(backupRole, replacer)) {

                var options = {
                    form: $scope.roleForm,
                    next: transition.to().name,
                    name: $scope.role.roleName,
                    success: $scope.submit,
                    dismiss: $scope.redirect,
                    perms: $scope.hasPerms
                };

                ngDroUtilsNotify.confirmUnsavedChanges(options);

                return false; // equivale al vecchio event.preventDefault();
            }

        }

        // scarica tutti i dati
        function getAllPerms() {
            ngDroUAA.Role.findAllPerms().then(function (response) { // Scarico i permessi
                $scope.perms = response.data;

                if (angular.isUndefined($stateParams.id)) { // Scarico il ruolo
                    $scope.role = {
                        id: null,
                        rolePermissions: []
                    };
                    angular.copy($scope.role, backupRole);
                } else {
                    ngDroUAA.Role.findOne($stateParams.id).then(function (response) {
                        $scope.role = response.data;
                        angular.copy($scope.role, backupRole);
                    }).catch(function (err) {
                        ngDroUtilsNotify.error(null, 'jdro_role.notify_error_get.role', null, err);
                    });
                }
            }).catch(function (err) {
                ngDroUtilsNotify.error(null, 'jdro_role.notify_error_get.perms', null, err);
            });
        }
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/role/roleDetail/roleDetailCtrl.js
// module id = 428
// module chunks = 0